import { Box, Grid } from '@mui/material';
import { RemoveCircleOutline, InfoOutlined, CheckCircleOutlined, WarningAmber } from '@mui/icons-material';
import BannerType from './bannerType';

export default function BannerIcon({ type }) {
  function BannerIconType() {
    switch (type) {
      case BannerType.SUCCESS:
        return <CheckCircleOutlined sx={{ color: 'white', margin: '5px', fontSize: '2rem' }} />;
      case BannerType.INFO:
        return <InfoOutlined sx={{ color: 'white', margin: '5px' }} />;
      case BannerType.WARNING:
        return <WarningAmber sx={{ color: 'white', margin: '5px' }} />;
      case BannerType.ERROR:
        return <RemoveCircleOutline sx={{ color: 'white', margin: '5px' }} />;
      default:
        return <></>;
    }
  }

  function getIconColor() {
    switch (type) {
      case BannerType.SUCCESS:
        return 'success.main';
      case BannerType.INFO:
        return 'info.main';
      case BannerType.WARNING:
        return 'warning.main';
      case BannerType.ERROR:
        return 'danger.main';
      default:
        return 'default.main';
    }
  }

  return (
    <Box
      sx={{
        backgroundColor: getIconColor(),
        borderRadius: '5px',
        position: 'relative',
      }}
    >
      <Grid container justifyContent="center">
        <BannerIconType />
      </Grid>
    </Box>
  );
}
